import {
  Component,
  ElementRef,
  HostListener,
  Input,
  QueryList,
  Renderer2,
  TemplateRef,
  ViewChild,
  ViewChildren,
  ChangeDetectorRef,
  OnInit,
  EventEmitter,
  Output,
} from "@angular/core";
import { FormBuilder, FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { EndorsementPopupComponent } from "../../../popup/endorsement-popup/endorsement-popup.component";
import {
  STORE_EHAILING_DETAILS,
  STORE_ENDORSEMENT,
  STORE_PREV_EHAILING_DETAILS,
  UPDATE_ENDORSEMENT_STEP2
} from '@store/sat-motor/sat-motor.action';
import { Store, Select } from '@ngxs/store';
import { ActivatedRoute, Router } from '@angular/router';
import { SatMotorState } from "@store/sat-motor/sat-motor.state";
import { SharedModule } from "../../../shared/shared.module";
import { NxSmallStageModule } from '@aposin/ng-aquila/small-stage';
import { NxDialogService, NxModalRef } from '@aposin/ng-aquila/modal';
import { CdkTextareaAutosize, TextFieldModule } from '@angular/cdk/text-field';
import { CoveragePopupComponent } from "../../../popup/coverage-popup/coverage-popup.component";
import { Subject, takeUntil } from 'rxjs';
import { combineToDate, inBetween, splitNRIC } from '../../helpers/service.helper';
import { NricService } from '@services/nric/nric.service';
import { EHailingDriverComponent } from '@shared/components/e-hailing-driver/e-hailing-driver.component';
import { SimpleModalComponent } from '@shared/components/modal/simple-modal/simple-modal.component';

@Component({
  selector: 'app-named-driver',
  standalone: true,
  imports: [
    SharedModule,
    NxSmallStageModule,
    TextFieldModule,
    EHailingDriverComponent
  ],
  templateUrl: './named-driver.component.html',
  styleUrl: './named-driver.component.scss'
})
export class NamedDriverComponent implements OnInit {
  /*
  * pending type coverage to connect to BE to get the default driver name, driver age and driver id list
  */

  @Select(SatMotorState.endtStep2EndorsementDetails) endtEndorsementDetailsData$;

  templateDialogRef?: NxModalRef<any>;

  @ViewChild("template") templateRef!: TemplateRef<any>;
  @ViewChild("template2") templateRef2!: TemplateRef<any>;
  @ViewChild("templatePolicyTable") templateRef3!: TemplateRef<any>;
  @ViewChild("autosize") autosize!: CdkTextareaAutosize;
  @ViewChild('warningPopup') warningPopup!: TemplateRef<any>;

  tableHolder: any;
  toText(value: string): string | null {
    return value ? value.toUpperCase() : null;
  }

  @Input() defaultDriver: any;
  @Input() parentForm: FormGroup;
  @Output() selectExtraCover = new EventEmitter<any>();
  @Output() removeExtraCover = new EventEmitter<any>();
  @Output() endtCalculatePremium = new EventEmitter<unknown>();

  userInfo: any;
  driverNameForm: FormGroup;
  driverNameList: any;
  isDisableAddDriverBtn: boolean;
  isComprehensive: boolean = false;
  isThirdParty: boolean = false;
  isThirdPartyFireTheft: boolean = false;
  product: any;

  unsubscribe$ = new Subject<void>();

  @Input() endorsementType: any;

  endtVehiclePolicyData: any;
  driverNameDetails: any;
  eHailingDetails: any;
  riskList: any;
  coverList: any;
  waiverOfCompulsory: boolean = false;
  allDriverInd: boolean = false;
  defaultDriverList: any;
  defaultEHailingList: any;
  checkPrivateHireCar = [];
  showEHailingComponent: boolean = false;

  // Dialog management
  openDialog(template: TemplateRef<any>, config: { height?: string; width?: string } = {}): void {
    this.templateDialogRef = this.dialogService.open(template, {
      disableClose: true,
      height: config.height || '500px',
      width: config.width || '780px',
    });
  }

  closeDialog(): void {
    this.templateDialogRef?.close();
  }

  constructor(
    private readonly dialogService: NxDialogService,
    private elementRef: ElementRef,
    private renderer: Renderer2,
    private fb: FormBuilder,
    private cdr: ChangeDetectorRef,
    private router: Router,
    public store: Store,
    private nricService: NricService,
  ) { }

  ngOnInit() {
    this.endtVehiclePolicyData = this.store.selectSnapshot<any>(state => state.SatMotorState?.endorsement?.step1?.endtVehicleData);

    this.userInfo = this.store.selectSnapshot<any>(state => state.UserState.user);
    this.product = this.endtVehiclePolicyData.productCode;
    
    this.riskList = this.endtVehiclePolicyData?.riskList[0];
    this.coverList = this.riskList?.coverList[0];
    if (this.coverList?.subCoverList) {
      this.waiverOfCompulsory = this.coverList.subCoverList.some(obj => obj.subCoverCode === 'A200' || obj.subCoverCode === 'M02');
    }
    this.isAllDriverInd();
    this.getCoverInfo(this.coverList.coverCode);
    this.getDriverDetails();
    this.getEHailingDetails();
    if(this.coverList?.subCoverList){
      this.privateHireCar();
    }

    this.driverNameForm = this.fb.group({
      rows: this.fb.array([]),
      ehailingDriverDetails: new FormGroup({})
    });

    if (this.driverNameDetails.rows && this.driverNameDetails.rows.length) {
      this.driverNameDetails.rows.forEach((drv, index) => {
        const hasM02 = this.coverList?.subCoverList?.some(obj => obj.subCoverCode === 'M02');
        const shouldDisable = index === 0 && (hasM02 || !["080200", "080300"].includes(this.product));

        this.rows.push(this.fb.group({
          driverName: [{ value: drv.driverName, disabled: shouldDisable }, Validators.required],
          driverId: [{ value: drv.driverId, disabled: shouldDisable }],
          driverAge: [{ value: drv.driverAge, disabled: shouldDisable ? true : this.isIdTypeNRIC(drv.driverId) }]
        }));
      });

      if (!this.defaultDriverList) {
        this.defaultDriverList = JSON.parse(JSON.stringify(this.driverNameForm.getRawValue().rows));
      }
      console.log('Default Driver Data >> ', this.defaultDriverList);
    } else {
      console.warn("No driver details available");
    }

    if (this.eHailingDetails.rows && this.eHailingDetails.rows.length) {
      this.store.dispatch(new STORE_EHAILING_DETAILS(this.endorsementType, this.eHailingDetails.rows)); 
    }

    this.isDisableAddDriverBtn = this.disableAddDriver();
  }

  isAllDriverInd() {
    if (this.riskList?.cngeRiskDrvrDtoList && this.riskList?.cngeRiskDrvrDtoList.length > 0) {
      let driverData = this.riskList?.cngeRiskDrvrDtoList[0];
      if (driverData && driverData.cngeRiskDrvrPkDto && driverData.cngeRiskDrvrPkDto.driverName) {
        let driverName = driverData.cngeRiskDrvrPkDto.driverName;
        let driverType = driverData.cngeRiskDrvrPkDto.driverType;
        if (driverType === 'NORM' && driverName === 'ALL RIDER/DRIVER') {
          this.allDriverInd = true;
        }
      }
    }
  }

  getCoverInfo(coverCode: any) {
    if (coverCode) {
      this.isComprehensive = coverCode === '01';
      this.isThirdParty = coverCode === '20';
      this.isThirdPartyFireTheft = coverCode === '30';
    }
  }

  getDriverDetails(): any {
    let step2Data = this.store.selectSnapshot(SatMotorState.endtStep2EndorsementDetails);

    if (step2Data && step2Data?.namedDriver && step2Data?.namedDriver?.rows) {
      this.driverNameDetails = {
        rows: step2Data.namedDriver.rows
      }
      this.defaultDriverList = step2Data?.defaultDriver;
    } else {
      this.driverNameDetails = {
        rows: this.riskList?.cngeRiskDrvrDtoList?.filter(d => d.cngeRiskDrvrPkDto.driverType === "NORM")?.map(a => {
          return {
            driverName: a.cngeRiskDrvrPkDto.driverName,
            driverId: a.driverId ?? 'N/A',
            driverAge: (a.driverAge && a.driverAge != '0') ? a.driverAge : 'N/A',
            driverSeq: a.driverSeq
          }
        }),
        vehicleUnNamedDrvrInd: this.riskList?.coverList[0]?.vehicleUnNamedDrvrInd
      }
    }
  }

  getEHailingDetails(): any {
    let step3Data = this.store.selectSnapshot(SatMotorState.endorsementStep3);

    if (step3Data?.coverage?.extracover?.ehailingDriverDetails?.rows) {
      this.eHailingDetails = {
        rows: step3Data.coverage?.extracover?.ehailingDriverDetails?.rows
      }
    } else {
      this.eHailingDetails = {
        rows: this.riskList?.cngeRiskDrvrDtoList?.filter(d => d.cngeRiskDrvrPkDto.driverType === "EHAIL")?.map(a => {
          return {
            driverName: a.cngeRiskDrvrPkDto.driverName,
            driverId: a.driverId ?? 'N/A',
            driverAge: (a.driverAge && a.driverAge != '0') ? a.driverAge : 'N/A',
            driverSeq: a.driverSeq
          }
        }),
        vehicleUnNamedDrvrInd: this.riskList?.coverList[0]?.vehicleUnNamedDrvrInd
      }

      this.defaultEHailingList = {
        rows: this.riskList?.cngeRiskDrvrDtoList?.filter(d => d.cngeRiskDrvrPkDto.driverType === "EHAIL")?.map(a => {
          return {
            driverName: a.cngeRiskDrvrPkDto.driverName,
            driverId: a.driverId ?? 'N/A'
          }
        }),
        vehicleUnNamedDrvrInd: this.riskList?.coverList[0]?.vehicleUnNamedDrvrInd
      }

      if (this.eHailingDetails.rows && this.eHailingDetails.rows.length) {
        this.store.dispatch(new STORE_PREV_EHAILING_DETAILS(this.defaultEHailingList.rows));
      }
    }
  }

  privateHireCar() {
    if(this.coverList?.subCoverList && this.coverList?.subCoverList.length > 0){
      this.checkPrivateHireCar = this.coverList.subCoverList.find(obj => obj.subCoverCode === 'A202');
      if (this.checkPrivateHireCar && this.checkPrivateHireCar.length) {
        this.showEHailingComponent = true;
      } else {
        this.showEHailingComponent = false;
      }
    }
    
  }

  validateEhailingDriver() {
      if (this.checkPrivateHireCar && this.checkPrivateHireCar.length) {
        const ehailingDriverDetails = this.driverNameForm.controls["ehailingDriverDetails"].getRawValue()?.rows;
        if (ehailingDriverDetails) {
          let driver = ehailingDriverDetails.map((d) => { return d.driverId + d.driverName; });
          if (!driver.filter(Boolean).length) {
            this.dialogService.open(SimpleModalComponent, {
              showCloseIcon: false, width: "400px", maxWidth: "400px",
              disableClose: true,
              data: { type: 'WARNING', message: "Minimum 1 e-Hailing driver is required." },
            });
            return false;
          } else {
            let filteredDrivrList = [];
            if (ehailingDriverDetails && ehailingDriverDetails.length > 0) {
              filteredDrivrList = ehailingDriverDetails.filter(driver => driver.driverName && driver.driverId);
            }
            this.store.dispatch(new STORE_EHAILING_DETAILS(this.endorsementType, filteredDrivrList));
          }
        }
      }

    return true;
  }

  // Method to add a row to the FormArray
  addRow(driverName: string, driverId: string, driverAge: string) {
    const rowGroup = this.fb.group({
      driverName: [driverName, [Validators.required, Validators.maxLength(100)]],
      driverId: [driverId, [Validators.required, Validators.maxLength(20)]],
      driverAge: [driverAge, [Validators.required, Validators.maxLength(3)]]
    });
    this.rows.push(rowGroup);
  }

  defaultAllDriverInd() {
    if (this.product === '080200' || this.product === '080300') {
      this.selectExtraCover.emit("M02");
      return true;
    } else {
      return false;
    }
  }

  addDriver() {
    let driverNameRow;

    driverNameRow = this.fb.group({
      driverName: [''],
      driverId: [''],
      driverAge: ['']
    });

    this.rows.push(driverNameRow);

    this.isDisableAddDriverBtn = this.disableAddDriver();


    console.log("rows: ", this.rows);
  }

  deleteDriver(index) {
    this.rows.removeAt(index);

    this.isDisableAddDriverBtn = this.disableAddDriver();

  }

  allDriverOnChange() {
    let allDriverInd = this.driverNameForm.controls['allDriverInd'].value;

    if (allDriverInd) {
      this.deleteSecondRowOnwards();
      this.rows.at(0).get('driverName').setValue(this.defaultDriver.cngeRiskDrvrPkDto.driverName);
      this.rows.at(0).get('driverId').setValue(this.defaultDriver.driverId);
      this.rows.at(0).get('driverAge').setValue(this.defaultDriver.driverAge);
      this.selectExtraCover.emit("M02");
    } else {
      this.rows.at(0).reset();
      this.removeExtraCover.emit("M02");
    }
    this.isDisableAddDriverBtn = this.disableAddDriver();
  }

  deleteSecondRowOnwards() {
    for (let i = this.rows.length - 1; i >= 1; i--) {
      this.rows.removeAt(i);
    }
  }

  disableAddDriver() {
    let driverListLength = this.rows.length;
    let disable = false;

    if (this.allDriverInd || this.waiverOfCompulsory || this.isThirdParty || this.isThirdPartyFireTheft) {
      disable = true;
    } else {
      switch (this.product) {
        case '080100':
          disable = driverListLength >= 3 ? true : false;
          break;

        case '080200':
        case '080300':
          disable = driverListLength >= 2 ? true : false;
          break;
      }
    }
    return disable;
  }

  isIdTypeNRIC(driverId) {
    let isValidNric;
    try {
      isValidNric = this.nricService.isNRICValid(driverId);
    } catch (err) {
      isValidNric = false;
    }

    return isValidNric;
  }

  onChangeDriverId(index) {
    let driverId = this.rows.at(index).get('driverId').value;
    let isValidNric;

    try {
      isValidNric = this.nricService.isNRICValid(driverId);
    } catch (err) {
      isValidNric = false;
    }

    if (isValidNric) {
      const [input, year, month, day, birthPlace, ...rest] = splitNRIC(driverId);
      const driverBirthDate = combineToDate(year, month, day);
      const todayDate = new Date();

      if (driverBirthDate.getFullYear() > todayDate.getFullYear()) {
        throw new Error('Invalid Driver ID');
      } else {
        this.rows.at(index).get('driverAge').disable();
        let driverAge = todayDate.getFullYear() - driverBirthDate.getFullYear();
        this.rows.at(index).get('driverAge').setValue(driverAge);
      }
    } else {
      this.rows.at(index).get('driverAge').enable();
    }
  }

  get isPrivateCarsExcludingGoods() {
    return this.product === '080100';
  }

  get isPrivateCarsIncludingGoods() {
    return this.product === '080200';
  }

  get isPrivateCarsCompanyRegistered() {
    return this.product === '080300';
  }

  get rows() {
    return this.driverNameForm.get('rows') as FormArray;
  }

  //////////////////////////////////////////////////////////////////////

  closeTemplateDialog() {
    this.templateDialogRef?.close();
  }

  componentDialogRef1?: NxModalRef<EndorsementPopupComponent>;

  openPopup(popup_type: any) {
    this.componentDialogRef1 = this.dialogService.open(EndorsementPopupComponent, {
      ariaLabel: "A simple dialog",
      showCloseIcon: false,
      disableClose: true,
      width: '400px',
      data: { popup_type: popup_type },
    });
  }

  openPopup3(popup_type: any) {
    this.componentDialogRef1 = this.dialogService.open(EndorsementPopupComponent, {
      ariaLabel: "A simple dialog",
      showCloseIcon: false,
      disableClose: true,
      data: { popup_type: popup_type },
    });
  }

  storeEndorsementDetailsData() {

    if (this.driverNameForm.valid && this.hasDriverName()) {
      let namedDriver = this.driverNameForm.getRawValue();
      console.log('Saving Named Driver Data:', namedDriver);
      let payload = {
        namedDriver: namedDriver,
        isNamedDriver: true,
        defaultDriver: this.defaultDriverList,
        ...(this.defaultEHailingList && {
          defaultEhailDriver: this.defaultEHailingList
        })
      }
      this.store.dispatch(new STORE_ENDORSEMENT(payload));

      let cngeDriverList = this.prepareDriverDataForPayload(namedDriver.rows);

      let endtUpdatedData = this.store.selectSnapshot<any>(state => state.SatMotorState?.endorsement?.step2?.endtUpdatedData);
      if (endtUpdatedData) {
        let updatedRisk = {
          ...endtUpdatedData.riskList[0],
          cngeRiskDrvrDtoList: cngeDriverList
        }

        endtUpdatedData = {
          ...endtUpdatedData,
          riskList: [updatedRisk]
        }
      }

      this.store.dispatch(new UPDATE_ENDORSEMENT_STEP2({
        isReset: false,
        cngeNote: endtUpdatedData
      })).subscribe(() => {
        this.endtCalculatePremium.emit();
      });

    } else {
      console.log('Named Driver form is invalid!');
      this.driverNameForm.markAllAsTouched();
      return;
    }
  }

  hasDriverName() {
    let allRowsHasName = true;
    let namedDriver = this.driverNameForm.getRawValue();
    let rows = namedDriver.rows;

    rows.forEach(row => {
        if (!row.driverName || row.driverName.trim() === '') {
            allRowsHasName = false;
        }
    });

    return allRowsHasName;
  }

  isDriverOrEHailingDataUpdated() {
    let isChanged = false;

    const defaultRowsStringified = JSON.stringify(this.defaultDriverList);
    const updatedRowsStringified = JSON.stringify(this.driverNameForm.getRawValue().rows);
    console.log('Updated Driver Data >> ', JSON.parse(updatedRowsStringified));

    if (this.checkPrivateHireCar && this.checkPrivateHireCar.length) {
      let step3Data = this.store.selectSnapshot(SatMotorState.endorsementStep3);
      if (step3Data?.coverage?.extracover?.prevEhailingDriverDetails?.rows) {
        this.defaultEHailingList = {
          rows: step3Data.coverage?.extracover?.prevEhailingDriverDetails?.rows
        }
      }
      const defaultEhailingRowsStringifield = JSON.stringify(this.defaultEHailingList?.rows ?? "");
      const updatedEhailingRowsStringified = JSON.stringify(this.driverNameForm.controls["ehailingDriverDetails"].getRawValue().rows);

      if (defaultRowsStringified !== updatedRowsStringified || defaultEhailingRowsStringifield !== updatedEhailingRowsStringified) {
        isChanged = true;
      }

    } else {
      if (defaultRowsStringified !== updatedRowsStringified) {
        isChanged = true;
      }
    }

    return isChanged;
  }
  

  prepareDriverDataForPayload(namedDriverList) {
    let driverSeqValue = 0;

    return namedDriverList.map((driver) => {
      let driverName;
      if (driver.driverName) {
        driverName = driver.driverName;
      } else if (driver?.cngeRiskDrvrPkDto?.driverName) {
        driverName = driver.cngeRiskDrvrPkDto.driverName;
      }

      let cngeRiskDrvrPkDto = {
        cngeRiskDrvrPkDto: {
          driverName: driverName ? driverName : "",
          driverType: "NORM",
        },
        driverId: driver.driverId,
        driverAge: driver.driverAge,
        driverSeq: driverSeqValue++
      };

      return cngeRiskDrvrPkDto;
    });
  }

  openWarningPopup(popupMessage: string): void {
    this.dialogService.open(this.warningPopup, {
      disableClose: true,
      width: '400px',
      data: { popup_message: popupMessage }
    });
  }

}
